/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  FailureResponseResponse,
  GetCashDeclarationHistoryV2Params,
  GetCashDeclarationHistoryV2ResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get cash declaration history records of all accounting locations V2
 * @summary Get cash declaration history records of all accounting locations history V2
 */
export const getCashDeclarationHistoryV2 = (
  params?: GetCashDeclarationHistoryV2Params,
  signal?: AbortSignal,
) => {
  return customInstance<GetCashDeclarationHistoryV2ResponseResponse>({
    url: `/BboCashManagementService/v2/cash-declaration/history`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetCashDeclarationHistoryV2QueryKey = (
  params?: GetCashDeclarationHistoryV2Params,
) => {
  return [
    `/BboCashManagementService/v2/cash-declaration/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCashDeclarationHistoryV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getCashDeclarationHistoryV2>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashDeclarationHistoryV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashDeclarationHistoryV2>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCashDeclarationHistoryV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashDeclarationHistoryV2>>> = ({
    signal,
  }) => getCashDeclarationHistoryV2(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCashDeclarationHistoryV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCashDeclarationHistoryV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getCashDeclarationHistoryV2>>
>;
export type GetCashDeclarationHistoryV2QueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Get cash declaration history records of all accounting locations history V2
 */
export const useGetCashDeclarationHistoryV2 = <
  TData = Awaited<ReturnType<typeof getCashDeclarationHistoryV2>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashDeclarationHistoryV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashDeclarationHistoryV2>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCashDeclarationHistoryV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
